<script setup>
const { t, locale } = useI18n();

const stemPrefix = computed(() => (locale.value === "fr" ? "blog/" : `${locale.value}/blog/`));
const { data } = await useAsyncData(
  `blogs-${locale.value}`,
  () =>
    queryCollection("blog")
      .where("stem", "LIKE", `${stemPrefix.value}%`)
      .select("stem", "title", "description")
      .all(),
  { watch: [locale] },
);

useSeoMeta({
  title: t('blog.seo.title'),
  description: t('blog.seo.description'),
});

useSchemaOrg([
  defineSoftwareApp({
    name: "Contrat IA",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web-based",
    url: "https://contrat-ia.com",
    aggregateRating: {
      "@type": "AggregateRating",
      "bestRating": "5",
      "ratingValue": "5",
      "ratingCount": "1",
      "itemReviewed": {
        "@type": "MediaObject",
        "name": t('schemaOrg.softwareApp'),
      },
    },
  }),
]);
</script>

<template>
  <div class="pt-24 sm:pt-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-2xl lg:mx-0">
        <h2 class="font-serif text-4xl font-semibold text-gray-900 sm:text-5xl">
          {{ t('blog.pageTitle') }}
        </h2>
        <p class="mt-2 text-lg/8 text-gray-600">
          {{ t('blog.pageSubtitle') }}
        </p>
      </div>

      <div class="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <article
          v-for="post in data"
          :key="post.stem"
          class="flex max-w-xl flex-col items-start justify-between"
        >
          <div class="group relative">
            <h3 class="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600">
              <NuxtLinkLocale :to="`/blog/${post.stem?.replace(/^(.*\/)?blog\//, '')}`">
                <span class="absolute inset-0" />
                <Icon
                  class="mr-1 size-4 text-primary-600"
                  name="lucide:file-text"
                />
                {{ post.title }}
              </NuxtLinkLocale>
            </h3>
            <p class="mt-5 line-clamp-3 text-sm/6 text-gray-600">
              {{ post.description }}
            </p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
